import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import 'maplibre-gl/dist/maplibre-gl.css';
import '@fontsource-variable/manrope';
import './index.css';

import { App } from '@/App';
import { config } from '@/config';
import { installGtm } from '@/services/gtm';

installGtm(config.gtmId);

const root = document.getElementById('root');

if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
